module.exports = __webpack_public_path__ + "static/media/galerija_2014 (15).248e0b36.jpg";